import {action, observable} from 'mobx';

import ApiBaseStore from '../common/apiBaseStore';

/**
 * Get all sheets for a company from the Schedule database.
 */
class ApiPaginationStore extends ApiBaseStore {
  /**
   * Meta data for the store for pagination.
   *
   * @type {any}
   */
  @observable meta = null;

  /**
   * Gets the meta value of the store.
   *
   * @returns {?{}}
   */
  getMeta() {
    return this.meta;
  }

  /**
   * Refresh data if necessary
   *  Main method to use when you want to use this store
   *
   * @param {{}} data
   * @param {number?} data.page pass through which page should be used
   * @param {string?} data.search search string
   * @param {string?} data.sort sort field
   * @param {string?} data.direction sort direction
   * @param {boolean} force Whether or not to force the refresh
   */
  refresh({
    page = 1,
    search = '',
    sort = 'updatedAt',
    direction = 'desc',
  }, force) {
    if (force || !this.isDataAvailable()) {
      this.clear();

      this.makeRequest({
        page,
        search,
        sort,
        direction,
      });
    }
  }

  /**
   * Checks if there is more data results available for pagination
   *
   * @returns {boolean}
   */
  hasNextPage() {
    return this.meta && this.meta.current_page < this.meta.last_page;
  }

  /**
   * Gets the next page of data if the request is paginated
   *
   * @param {{}} data
   * @param {string?} search search string
   * @param {string?} data.sort sort field
   * @param {string?} data.direction sort direction
   */
  @action getNextPage({
    search = '',
    sort = 'updatedAt',
    direction = 'desc',
  }) {
    if (this.meta && this.meta.current_page < this.meta.last_page) {
      this.makeRequest({
        page: this.meta.current_page + 1,
        search,
        sort,
        direction,
      });
    }
  }
}

export default ApiPaginationStore;
export const doNotInject = true;
